Ext.define('SA.view.map.menu.MapMenuItem', {
    extend: 'Ext.menu.CheckItem',

    getMapModel() {
        return this.projectView;
    }
});